import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.59,10.6a.77.77,0,0,1-.52.21.74.74,0,0,1-.54-.23L8.75,7.7V14a.75.75,0,0,1-1.5,0V7.7L4.47,10.58a.75.75,0,0,1-1.06,0,.76.76,0,0,1,0-1.06L7.46,5.32a.85.85,0,0,1,.25-.17.73.73,0,0,1,.58,0,.85.85,0,0,1,.25.17l4.07,4.22A.75.75,0,0,1,12.59,10.6ZM14.75,2A.76.76,0,0,0,14,1.25H2a.75.75,0,0,0,0,1.5H14A.76.76,0,0,0,14.75,2Z';
const draw24px =
  'M12,20.75a.75.75,0,0,1-.75-.75V10.49L9,12.76a.74.74,0,0,1-1.06,0,.75.75,0,0,1-.22-.53.79.79,0,0,1,.22-.53l3.56-3.55A.78.78,0,0,1,11.72,8a.73.73,0,0,1,.58,0,.78.78,0,0,1,.24.16l3.55,3.55a.75.75,0,0,1,0,1.06.74.74,0,0,1-1.06,0l-2.27-2.27V20A.76.76,0,0,1,12,20.75Zm-8-16H20a.75.75,0,0,0,0-1.5H4a.75.75,0,0,0,0,1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowAlignUpIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowAlignUp'),
) as IconWithRender;

ArrowAlignUpIcon.displayName = 'ArrowAlignUpIcon';
ArrowAlignUpIcon.propTypes = Icon.propTypes;
ArrowAlignUpIcon.renderIcon = (props) => <ArrowAlignUpIcon {...props} />;
export default ArrowAlignUpIcon;
